module.exports = __webpack_public_path__ + "media/images/svgs/socks-icon-10530bbaa8693570c7b7b43adc0e3c7a.svg";